import { PsychologicalDocumentsUseCase } from '../../../../data/usecases'
import { makeAxiosHttpClient } from '../../../factories'

type fetchReportModel = {
  id: string | number
}

export const fetchReport = ({ id }: fetchReportModel) => {
  return new PsychologicalDocumentsUseCase(
    `/laudo/load/${id}`,
    makeAxiosHttpClient()
  )
}

export const saveReport = ({ id }: fetchReportModel) => {
  return new PsychologicalDocumentsUseCase(
    `/laudo/save/${id}`,
    makeAxiosHttpClient()
  )
}

export const updateReport = ({ id }: fetchReportModel) => {
  return new PsychologicalDocumentsUseCase(
    `/laudo/update/${id}`,
    makeAxiosHttpClient()
  )
}

export const resetReport = ({ id }: fetchReportModel) => {
  return new PsychologicalDocumentsUseCase(
    `/laudo/reset/${id}`,
    makeAxiosHttpClient()
  )
}
